import BaseService from './baseService'
import axios from 'axios'
import { useAppState } from '../stores/AppState'

export class VerifyEmailResponse {
  success: boolean = false
  alreadyConfirmed: boolean = false
  errorMessage: string = ''
  redirectUri: string = ''
}

export class LoginResponse {
  data: any = {}
}

export class UserLoginService extends BaseService {
  allowedToLogin(email: string) {
    return new Promise<LoginResponse>((resolve, reject) => {
      axios
        .get(
          `${import.meta.env.VITE_HOST_URL}api/Authentication?email=${encodeURIComponent(email)}`,
          {
            headers: {
              'Cache-Control': 'no-cache',
              'content-type': 'application/vnd.api+json'
            }
          }
        )
        .then((result) => {
          if (result.status === 200) {
            resolve(result.data)
          } else {
            reject(new Error('User is not enabled'))
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            reject(new Error('User is not enabled'))
          } else {
            reject(new Error('An error occurred'))
          }
        })
    })
  }

  

  verifyEmailAddress(id: string, verificationCode: string): Promise<VerifyEmailResponse> {
    return new Promise<VerifyEmailResponse>((resolve, reject) => {
      return this.httpClient('RCRM')
        .postAnonymous('/RegisterConfirmation', { id: id, confirmationKey: verificationCode })
        .then((res) => {
          resolve(res.data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
}

export default new UserLoginService()
